module.exports = __webpack_public_path__ + "static/img/wsd_vx.80f0eab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wsd_vx.png
// module id = mQF6
// module chunks = 46